/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Contentminlength2Inputs */

const id_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten harus minimal 3 karakter`)
};

const ms_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kandungan mesti sekurang-kurangnya 3 aksara`)
};

const da_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indhold skal være mindst 3 tegn langt`)
};

const de_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Inhalt muss mindestens 3 Zeichen lang sein`)
};

const en_us2_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content must be at least 3 characters long`)
};

const es_es2_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido debe tener al menos 3 caracteres`)
};

const es_mx2_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido debe tener al menos 3 caracteres`)
};

const fil_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang nilalaman ay dapat na hindi bababa sa 3 character ang haba`)
};

const fr_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le contenu doit contenir au moins 3 caractères`)
};

const it_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il contenuto deve avere almeno 3 caratteri`)
};

const hu_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tartalomnak legalább 3 karakter hosszúnak kell lennie`)
};

const nl_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inhoud moet ten minste 3 tekens lang zijn`)
};

const no_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innholdet må være minst 3 tegn langt`)
};

const pl_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treść musi mieć co najmniej 3 znaki`)
};

const pt_br2_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content must be at least 3 characters long`)
};

const pt_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O conteúdo deve ter pelo menos 3 caracteres`)
};

const ro_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conținutul trebuie să aibă cel puțin 3 caractere`)
};

const fi_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisällön on oltava vähintään 3 merkkiä pitkä`)
};

const sv_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Innehållet måste vara minst 3 tecken långt`)
};

const vi_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nội dung phải có ít nhất 3 ký tự`)
};

const tr_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçerik en az 3 karakter uzunluğunda olmalıdır`)
};

const cs_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obsah musí mít alespoň 3 znaky`)
};

const bg_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Съдържанието трябва да е най-малко 3 знака`)
};

const ru_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Содержание должно содержать не менее 3 символов`)
};

const uk_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Текст має містити щонайменше 3 символи`)
};

const ar_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يحتوي المحتوى على 3 أحرف على الأقل`)
};

const hi_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सामग्री कम से कम 3 अक्षर`)
};

const th_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เนื้อหาต้องมีอย่างน้อย 3 ตัวอักษร`)
};

const ja_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内容は3文字以上である必要があります`)
};

const zh_cn2_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content must be at least 3 characters long`)
};

const zh_hant1_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content must be at least 3 characters long`)
};

const ko_forms_review_contentminlength2 = /** @type {(inputs: Forms_Review_Contentminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Content must be at least 3 characters long`)
};

/**
* | output |
* | --- |
* | "Content must be at least 3 characters long" |
*
* @param {Forms_Review_Contentminlength2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_contentminlength2 = /** @type {((inputs?: Forms_Review_Contentminlength2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Contentminlength2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_contentminlength2(inputs)
	if (locale === "ms") return ms_forms_review_contentminlength2(inputs)
	if (locale === "da") return da_forms_review_contentminlength2(inputs)
	if (locale === "de") return de_forms_review_contentminlength2(inputs)
	if (locale === "en-US") return en_us2_forms_review_contentminlength2(inputs)
	if (locale === "es-ES") return es_es2_forms_review_contentminlength2(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_contentminlength2(inputs)
	if (locale === "fil") return fil_forms_review_contentminlength2(inputs)
	if (locale === "fr") return fr_forms_review_contentminlength2(inputs)
	if (locale === "it") return it_forms_review_contentminlength2(inputs)
	if (locale === "hu") return hu_forms_review_contentminlength2(inputs)
	if (locale === "nl") return nl_forms_review_contentminlength2(inputs)
	if (locale === "no") return no_forms_review_contentminlength2(inputs)
	if (locale === "pl") return pl_forms_review_contentminlength2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_contentminlength2(inputs)
	if (locale === "pt") return pt_forms_review_contentminlength2(inputs)
	if (locale === "ro") return ro_forms_review_contentminlength2(inputs)
	if (locale === "fi") return fi_forms_review_contentminlength2(inputs)
	if (locale === "sv") return sv_forms_review_contentminlength2(inputs)
	if (locale === "vi") return vi_forms_review_contentminlength2(inputs)
	if (locale === "tr") return tr_forms_review_contentminlength2(inputs)
	if (locale === "cs") return cs_forms_review_contentminlength2(inputs)
	if (locale === "bg") return bg_forms_review_contentminlength2(inputs)
	if (locale === "ru") return ru_forms_review_contentminlength2(inputs)
	if (locale === "uk") return uk_forms_review_contentminlength2(inputs)
	if (locale === "ar") return ar_forms_review_contentminlength2(inputs)
	if (locale === "hi") return hi_forms_review_contentminlength2(inputs)
	if (locale === "th") return th_forms_review_contentminlength2(inputs)
	if (locale === "ja") return ja_forms_review_contentminlength2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_contentminlength2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_contentminlength2(inputs)
	return ko_forms_review_contentminlength2(inputs)
});
export { forms_review_contentminlength2 as "forms.review.contentMinLength" }